import { render, staticRenderFns } from "./jiancha.vue?vue&type=template&id=b1efc5a4&scoped=true&"
import script from "./jiancha.vue?vue&type=script&lang=ts&"
export * from "./jiancha.vue?vue&type=script&lang=ts&"
import style0 from "./jiancha.vue?vue&type=style&index=0&id=b1efc5a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1efc5a4",
  null
  
)

export default component.exports